// extracted by mini-css-extract-plugin
export default {"PmaOnboardingWidgetAiButton":"IG4peI","pmaOnboardingWidgetAiButton":"IG4peI"};